<template>
    <div class="multiple-date-selection">
        <div class="form-group">
            <span v-show="dates.length == 0">
                No excluded dates
            </span>
            <ul>
                <li v-for="date in dates">
                    <span class="label label-success">{{ date }}</span> 
                    <a v-on:click.prevent.stop="this.removeItem(date)" class="btn btn-danger btn-xs" href="#">x</a>
                    <input type="hidden" name="excluded_dates[]" v-bind:value="date">
                </li>
            </ul>
        </div>
        <div class="form-group">
            <input type="text" v-model="dateInput" class="date" placeholder="Excluded date" name="date_input"  value="">
            <a href="#" v-on:click.prevent.stop="this.addItem(dateInput)" class="btn btn-primary">Add</a>
        </div>
    </div>
</template>

<script>
     export default {
        props: {
            excludedDates: {
                type: Array,
                default: function() {
                    return [];
                }
            }
        },
        data () {
            return {
                dates: this.excludedDates,
                dateInput: {},
            }
        },
        watch: {

        },
        methods: {
            removeItem: function(date) 
            {
                const i = this.dates.indexOf(date);
                this.dates.splice(i, 1);
            },
            addItem: function(date) 
            {
                if (this.dates.indexOf(date) === -1 && date != '') {
                    this.dates.push(date);
                }
            }
        },
        computed: {
            formExcludedDates() {
                return this.dates.join('#');
            }
        },
        events: {

        }
     };
</script>

<style>
  .multiple-date-selection {
    ul {
        li {
            list-style-type: none;
        }
    }
  }
</style>